import { render, staticRenderFns } from "./caseClip_patient.vue?vue&type=template&id=7660950b&scoped=true"
import script from "./caseClip_patient.vue?vue&type=script&lang=js"
export * from "./caseClip_patient.vue?vue&type=script&lang=js"
import style0 from "./caseClip_patient.vue?vue&type=style&index=0&id=7660950b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7660950b",
  null
  
)

export default component.exports